<template>
  <div class="cp__form w-100">
    <div class="cp__form__field__wrapper">
      <div>
        <b-form-group class="cp__form__field form__input" label-class="cp__form__field__label" label="First name" label-for="first_name">
          <b-form-input id="first_name" type="text" v-model.trim="customer.first_name" placeholder="First name"
                        class="customer checkout-form-input"></b-form-input>
        </b-form-group>
        <div v-if="errors && errors.first_name" class="text-danger input-error text-right pr-1">
          <small>{{ errors.first_name }}</small>
        </div>
      </div>
      <div>
        <b-form-group class="cp__form__field form__input" label-class="cp__form__field__label" label="Last name" label-for="last_name">
          <b-form-input id="last_name" type="text" v-model.trim="customer.last_name" placeholder="Last name"
                        class="customer checkout-form-input"></b-form-input>
        </b-form-group>
        <div v-if="errors && errors.last_name" class="text-danger input-error text-right pr-1">
          <small>{{ errors.last_name }}</small>
        </div>
      </div>
    </div>
    <div>
      <b-form-group class="cp__form__field form__input" label-class="cp__form__field__label" label="Phone number" label-for="phone_number">
        <b-form-input id="phone_number" type="text" v-model.trim="customer.phone" placeholder="Phone Number"
                      class="customer checkout-form-input"></b-form-input>
      </b-form-group>
      <div v-if="errors && errors.phone" class="text-danger input-error text-right pr-1">
        <small>{{ errors.phone }}</small>
      </div>
    </div>
    <div>
      <b-form-group class="cp__form__field form__input" label-class="cp__form__field__label" label="Email" label-for="email">
        <b-form-input id="phone_number" type="email" v-model.trim="customer.email" placeholder="Email"
                      class="customer checkout-form-input"></b-form-input>
      </b-form-group>
      <div v-if="errors && errors.email" class="text-danger input-error text-right pr-1">
        <small>{{ errors.email }}</small>
      </div>
    </div>
    <div>
      <b-form-group class="cp__form__field form__input" label-class="cp__form__field__label" label="Address 1" label-for="address1">
        <b-form-input id="address1" type="text" v-model.trim="customer.address1" placeholder="Address 1"
                      class="customer checkout-form-input"></b-form-input>
      </b-form-group>
      <div v-if="errors && errors.address1" class="text-danger input-error text-right pr-1">
        <small>{{ errors.address1 }}</small>
      </div>
    </div>
    <b-form-group class="cp__form__field form__input" label-class="cp__form__field__label" label="Address 2" label-for="address2">
      <b-form-input id="address2" type="text" v-model.trim="customer.address2" placeholder="Address 2"
                    class="customer checkout-form-input"></b-form-input>
    </b-form-group>
    <div>
      <b-form-group class="cp__form__field form__input" label-class="cp__form__field__label" label="City" label-for="city">
        <b-form-input id="city" type="text" v-model.trim="customer.city" placeholder="City"
                      class="customer checkout-form-input"></b-form-input>
      </b-form-group>
      <div v-if="errors && errors.city" class="text-danger input-error text-right pr-1">
        <small>{{ errors.city }}</small>
      </div>
    </div>
    <div>
      <b-form-group class="cp__form__field form__input" label-class="cp__form__field__label" label="Country" label-for="country">
        <b-form-select id="country" v-model="customer.country" :options="countries" placeholder="Country" @change="countryChanged" class="customer select checkout-form-input"></b-form-select>
        <div v-if="errors && errors.country" class="text-danger input-error text-right pr-1">
          <small>{{ errors.country }}</small>
        </div>
      </b-form-group>
    </div>
    <div class="cp__form__field__wrapper">
      <div>
        <b-form-group class="cp__form__field form__input mb-0" label-class="cp__form__field__label" label="Province/State" label-for="state">
          <b-form-select v-if="isUsOrCA()" id="state" v-model="customer.state"
                         :options="getStates()" placeholder="State" class="customer checkout-form-input"
          ></b-form-select>
          <b-form-input v-if="!isUsOrCA()" id="state" type="text"
                        v-model.trim="customer.state" placeholder="State" class="customer checkout-form-input"
          ></b-form-input>
        </b-form-group>
        <div v-if="errors && errors.state" class="text-danger input-error text-right pr-1">
          <small>{{ errors.state }}</small>
        </div>
      </div>
      <div>
        <b-form-group class="cp__form__field form__input mb-0" label-class="cp__form__field__label" label="Postal Code" label-for="postal_code">
          <b-form-input id="postal_code" type="text" :formatter="zipFormat" v-model.trim="customer.zip" placeholder="Postal Code"
                        class="customer checkout-form-input"></b-form-input>
        </b-form-group>
        <div v-if="errors && errors.zip" class="text-danger input-error text-right pr-1">
          <small>{{ errors.zip }}</small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {formatZipField, getCountryStates, isCountryUSOrCA, getCountries} from '@/utils'
import {mapState} from 'vuex'

export default {
  name: 'AddressInfo',
  props: {
    addressPrefix: {
      type: String,
      default: ''
    },
    addressInfo: Object,
    errors: Object
  },
  data: function() {
    return {
      customer: {
        address1: null,
        address2: null,
        city: null,
        state: null,
        zip: null,
        first_name: null,
        last_name: null,
        email: null,
        phone: null,
        country: 'US'
      }
    }
  },
  computed: {
    ...mapState(['session', 'campaign']),
    countries() {
      return getCountries(this.session)
    }
  },
  methods: {
    getStates() {
      return getCountryStates(this.customer.country, this.campaign.blacklisted_states)
    },
    countryChanged() {
      this.customer.state = ''
      this.customer.zip = ''
    },
    isUsOrCA() {
      return isCountryUSOrCA(this.customer.country)
    },
    zipFormat(value) {
      return formatZipField(value, this.customer.country)
    }
  },
  created() {
    let customer = null
    if (this.addressInfo) {
      customer = this.addressInfo
    } else if (this.session && this.session.customer) {
      customer = this.session.customer
    }
    if (customer) {
      this.customer = {
        'email': customer.email,
        'phone': customer.phone,
        'address1': customer[this.addressPrefix + 'address1'],
        'address2': customer[this.addressPrefix + 'address2'],
        'city': customer[this.addressPrefix + 'city'],
        'state': customer[this.addressPrefix + 'state'],
        'zip': customer[this.addressPrefix + 'zip'],
        'first_name': customer[this.addressPrefix + 'first_name'] || customer['first_name'],
        'last_name': customer[this.addressPrefix + 'last_name'] || customer['last_name'],
        'country': customer[this.addressPrefix + 'country'] || 'US'
      }
    }
  }
}
</script>

<style scoped>

</style>
